import { useState, useRef } from "react"

import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import _ from 'lodash'
import { format } from 'date-fns'
import parse from 'html-react-parser'

import { LenisScroller } from '../fuselage/animation/lenis-scroller'
import { Reveal } from '../fuselage/animation/reveal'
import { Pop } from '../fuselage/animation/animation'


import { HeaderShim } from '../fuselage/global/header/header'

import { PageHeader } from '../fuselage/blocks/page-header/page-header'
import { StickySidebar } from '../fuselage/layout/sticky-sidebar/sticky-sidebar'

import { StopwatchIcon, LocationIcon, CompassIcon } from '../fuselage/components/icons/icons'
import { Modal } from '../fuselage/layout/modal/modal'

import CSS from '../css/app/agenda-2024-aag.module.css'



export default function Agenda ({ sessions, locations, theme }) {
	

	let LAB_SESSIONS = []

	sessions.map(session => {
		if (session.fields.find( field => field.id === 'RmllbGRWYWx1ZV8yNjg3NTk4MA==')) {
			LAB_SESSIONS.push(session)
		}
	})


	// BUILD AGENDA
	const buildAgenda = ( sessionsData ) => {

		if ( !sessionsData ) return 

		
		const timeslots = _.groupBy(sessionsData, 'beginsAt')
		

		// calculate event days

		const getUniqueDays = ( sessionData ) => {

			const groupedStartTimes = _.groupBy(sessionData, 'beginsAt')
			const timeCodes = Object.keys(groupedStartTimes)
			const eventDays = _.uniqBy( timeCodes, string => string.slice(0, 10) )
	
			return eventDays
		}
		
		const agendaDays = []
		getUniqueDays( sessionsData ).map((timestring, index) => {
			agendaDays.push({ 
				day: format( new Date(timestring), "eeee dd MMMM" ), 
				time: timestring.slice(0, 10), 
				timeslots: [] 
			})
		})


		// group sessions (and apply filters)

		const filteredTimeslots = _.groupBy(sessionsData, 'beginsAt')
		
	
		// build agenda
	
		const agenda = []
		agendaDays.map( day => {
			let slots = []
			for ( const key in filteredTimeslots ) {
				if ( key.slice(0, 10) === day.time.slice(0, 10) ) {
					slots.push({ 
						beginsAt: filteredTimeslots[key][0].beginsAt, 
						endsAt: filteredTimeslots[key][0].endsAt, 
						sessions: filteredTimeslots[key]
					})
				}
			}
	
			agenda.push( { ...day , timeslots: slots } )
		})

		return agenda
	}

	const getLocationTitleById = ( session ) => {
		const location = session.fields.find( field => field.definition.name === 'Location' )
		if ( !location ) return
		return location.translations[0].value
	}

	// console.log('sessions:', sessions)
	// console.log('locations [swc]:', locations)
	// console.log('theme:', theme)	
	console.log('LAB agenda:', buildAgenda(LAB_SESSIONS))	


    return (
        <div>

            <HeaderShim />

            <PageHeader theme={``}>
                <div className="formatted no-print">
                    <p className="fs-0 fw-600 lh-1"><Reveal>Net Positive Solutions Labs</Reveal></p>
					<p className="mt-sm">POWERED BY WORLD SUSTAINABLE HOSPITALITY ALLIANCE.</p>
                </div>

            </PageHeader>
			<p className="block py-0 fs-0 fw-600 print-only">FHS Africa 2025 Net Positive Solutions Labs</p>



            <section className="block">

				{
					buildAgenda(LAB_SESSIONS).map( (day, index) => (
						<StickySidebar key={index} size={'large'}>
							<aside>
								<p className={CSS.dayDivider}>{ day.day }</p>
							</aside>

							<main>
								<div className={CSS.sessions}>
									{
										day.timeslots.map( (slot, index) => (
											<SessionGroup key={index}>
												{
													slot.sessions.map( (session, index) => (
														<Session 
															key={index}
															duration={{ startTime: session.beginsAt, endTime: session.endsAt }}
															location={getLocationTitleById(session)}
															theme={"1"}
															title={session.titleTranslations[0].value}
															speakers={session.speakers}
														/>
													))
												}
												
											</SessionGroup>
										))
									}
								</div>
							</main>
						</StickySidebar>
					))
				}

            </section>


		<LenisScroller />
        </div>
    )
}


const Duration = ({ startTime, endTime }) => {

	const convertSeconds = (seconds) => {
		const hours = Math.floor(seconds / 3600)
		const minutes = Math.floor((seconds % 3600) / 60)
	
		const hourString = hours > 0 ? `${hours}h` : ''
		const minuteString = minutes > 0 ? `${minutes}m` : ''
	
		if ( hours > 0 ) {
			return `${hourString} ${ minutes > 0 ? minuteString : ''}`

		} else if ( !hours && minutes > 0 ) {
			return `${minuteString}`

		}
	
		return
	}


	return (
		<p className={CSS.sessionTagGrid}>
			{ format( new Date(startTime), "HH:mm" ) } - { endTime && format( new Date(endTime), "HH:mm" ) }
			{
				endTime &&
				<span>&ensp;<StopwatchIcon fill={'var(--primary)'}/> { convertSeconds(parseInt(new Date(endTime).getTime() - new Date(startTime).getTime())/1000) }</span>
			}
		</p>
	)
}

const Location = ({ location }) => {
	return (
		<p className={CSS.sessionTagGrid}><CompassIcon fill={'var(--primary)'} /> {location}</p>
	)
}

const SessionGroup = ({ location, duration, children }) => {

	if ( !children ) return

	return (
		<div className={CSS.sessionGroupContainer} style={{ borderColor: location?.color, backgroundColor: location?.color }}>
			{
				location || duration ?
					<div className={CSS.sessionHeader}>
						{
							duration &&
							<Duration startTime={duration.startTime} endTime={duration.endTime} />
						}
						{
							location &&
							<div className={`${CSS.sessionTagGrid} fs-sm`}>
								<LocationIcon fill={'var(--primary)'} /> { location }
							</div>
						}
					</div>
				: null
			} 

			<div className={CSS.sessionsGroupSessions}>
				{ children }
			</div>
		</div> 
	)
}

const Session = ({ duration, location, title, theme, speakers }) => {
	
	const breakTitle = ( trigger, titleString, splitPoint ) => {
		if ( !titleString.includes(trigger) ) return titleString
		let lines = titleString.split(splitPoint)
		return `${lines[0]}:<br/>${lines[1]}${lines.length > 2 ? `: ${lines[2]}` : ''}`		
	}

	const setSessionTheme = ( themeID ) => {

		switch (themeID) {
			case "1":
				//Knowledge HUB
				return "agenda-01"
				break
		
			case "2":
				//The Forum
				return "agenda-02"
				break
		
			case "3":
				//Pioneer HUB
				return "agenda-03"
				break
		
			case "4":
				//Future HUB
				return "agenda-04"
				break
		
			case "5":
				//Showcase HUB
				return "agenda-05"
				break
		
			default:
				return "bg-light"
				break
		}
	}

	return (
		<div className={CSS.sessionsWrapper}>
			{
				duration || location ?
					<div className={CSS.sessionHeader}>
						{ duration && <Duration startTime={duration.startTime} endTime={duration.endTime} /> }
						{ location && <Location location={location} /> }
					</div>
				: null
			}

			<div className={`${setSessionTheme(theme)} ${CSS.sessionContent}`}>
				<p className="fs-6 fw-600 lh-1 c-secondary">
					{ parse(breakTitle(":", title, ": ")) }
				</p>
				{
					speakers?.length 
					? sortSpeakers(_.orderBy(speakers, 'lastName'))
					: null
				}				
			</div>
		</div>
	)
}

const SpeakerCard = ({ speaker, type }) => {

	const [ showModal, setShowModal ] = useState(false)
    const [ modalContent, setModalContent ] = useState({ avatar: '', name: '', title: '', company: '', bio: ''})

	return (
		<Pop>

			<div key={speaker.id} className={CSS.sessionSpeaker}>
				{ type ? <p className="c-secondary fw-500 pb-xs">{ type }</p> : null }
				{
					speaker.photoUrl 
					?	<div className={`${CSS.speakerPhoto} ${speaker.biography && CSS.bio}`}
							onClick={() => {
								if ( speaker.biography ) {
									setModalContent({
										avatar: speaker.photoUrl,
										name: `${speaker.firstName} ${speaker.lastName}`,
										title: speaker.jobTitle,
										company: speaker.organization,
										bio: speaker.biography
									})
									setShowModal(true)
								}
							}}>
							{speaker.biography && <span><ProfileIcon color="white" /></span>}
							<img src={speaker.photoUrl} alt="" />
						</div>
					:	<div className={CSS.speakerPhoto}><img src={`/assets/ui/avatar-fallback.png`} alt="" /></div>

				}
				<p className="fw-600 c-black">{ speaker.firstName } { speaker.lastName }</p>
				<p className="fs-sm lh-1 c-black">{ speaker.jobTitle }<br />{ speaker.organization }</p>
			</div>

			<Modal onClose={() => setShowModal(false)} show={showModal}>
				<div style={{ maxHeight: '80vh', overflowY: 'scroll', paddingRight: 10 }}>
					<p className="fs-5 fw-600">{ modalContent.name }</p>
					<p className="fs-sm">{ modalContent.title }<br />{ modalContent.company }</p>
					<p className="mt-xs">{modalContent.bio}</p>
				</div>
			</Modal>
		</Pop>
	)
}

const ProfileIcon = ({ color = 'var(--primary)' }) => {

	return (
		<svg width="100%" height="100%" viewBox="0 0 24 15" style={{ fillRule:`evenodd`, clipRule:`evenodd`, strokeMiterlimit: 1.5 }}>
			<g id="icon-profile">
				<g id="icon-author">
					<circle cx="7.517" cy="5.135" r="3.763" style={{ fill:`none`, stroke: color, strokeWidth:1.5 }}/>
					<path d="M1.351,12.932C2.39,10.558 4.761,8.897 7.517,8.897C10.273,8.897 12.644,10.558 13.684,12.932" style={{ fill:`none`, stroke: color, strokeWidth:1.5 }}/>
				</g>
				<path d="M13.739,2.244L21.996,2.244" style={{ fill:`none`, stroke: color, strokeWidth:1.5 }}/>
				<path d="M13.739,6.649L21.996,6.649" style={{ fill:`none`, stroke: color, strokeWidth:1.5 }}/>
				<path d="M15.918,11.054L21.996,11.054" style={{ fill:`none`, stroke: color, strokeWidth:1.5 }}/>
			</g>
		</svg>
	)
}

const sortSpeakers = ( speakerData ) => {

	if ( !speakerData ) return

	// console.log('speakerData:', speakerData)

	let moderators = []
	let speakers = []

	speakerData.forEach( speaker => {
		speaker.withEvent?.eventProfile.type !== 'Speaker' ? moderators.push( speaker ) : speakers.push( speaker )
	})


	if ( moderators.length && speakers.length ) return (
		<section>
			{
				moderators.length ?
					<div>
						<p className="fw-500" style={{ padding: `0 0 15px 0`}}>Moderator{ moderators.length > 1 && 's'}</p>
						<div className={CSS.sessionSpeakerGrid}>
							{ moderators.map( moderator => <SpeakerCard key={moderator.id} speaker={moderator} /> ) }
						</div>
					</div>
				: null
			}
			<div>
				{
					moderators.length && speakers.length ?
						<p className="fw-500 mt-xxs" style={{ padding: `0 0 15px 0`}}>In conversation with</p>
					: null
				}
				<div className={CSS.sessionSpeakerGrid}>
					{ speakers.map( speaker => <SpeakerCard key={speaker.id} speaker={speaker} /> ) }
				</div>
			</div>

		</section>
	)

	return (
		<div className={CSS.sessionSpeakerGrid}>
			{ speakerData.map( speaker => <SpeakerCard key={speaker.id} speaker={speaker} /> ) }
		</div>
	)
}



export async function getStaticProps() {

	// swapcard API

    const eventQuery = await fetch(
		"https://developer.swapcard.com/event-admin/graphql",
		{
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Authorization": process.env.SWAPCARD_AUTH_KEY
			},
			body: JSON.stringify({
				query: `
					query EventById($eventId: ID!) {

						event(id: $eventId) {
							planningsPlaces {
								id
								name
								value
							}
						}

						plannings(eventId: "${process.env.SWAPCARD_EVENT_ID_2025}", page: 1, pageSize: 500) {
							id
							titleTranslations {
								value
								language
							}
							beginsAt
							endsAt
							descriptionTranslations {
								value
								language
							}
							format
							fields {
								... on SelectField {
									id
									definition {
										isDefault
										name
									}
									value
									translations {
										value
									}
								}
								... on MultipleSelectField {
									id
									definition {
										isDefault
										name
									}
									value
									translations {
										value
									}
								}
							}
							speakers {
								firstName
								id
								jobTitle
								lastName
								photoUrl
								organization
								biography
								withEvent(eventId: "${process.env.SWAPCARD_EVENT_ID_2025}") {
									eventProfile {
										type
										withEvent(eventId: "RXZlbnRfMTczOTgzMg==") {
											speakerOnPlannings {
												id
												title
												beginsAt
												endsAt
											}
										}
									}
								}
							}
							categories
						}
					}
				`,
				variables: {
					"eventId": process.env.SWAPCARD_EVENT_ID_2025,
					"page": 1
				}
			})
		}
	)

	
	const result = await eventQuery.json()



	// cms (theme etc)
    const cmsAgendaData = await craftApolloClient().query({
        query: gql`
			query SEO {
				entry(site: "${process.env.SITE_HANDLE}", id: "	16596") {
					title
                    ... on ${process.env.SITE_HANDLE}Agenda_${process.env.SITE_HANDLE}Agenda_Entry {
                        id
                        agendaTheme {
                            ... on agendaTheme_BlockType {
                                id
                                color
                                agendaTag
                            }
                        }
                    }
					seomatic (asArray: true) {
						metaTitleContainer
						metaTagContainer
					}
				}
			}
        `
    })


    return { 
        props: { 
            sessions: result.data.plannings,
			locations: result.data.event.planningsPlaces,
			theme: cmsAgendaData.data.entry.agendaTheme
        } 
    }
}

